module.exports = __webpack_public_path__ + "assets/img/info-btn-75bff0e6.png";